import { render, staticRenderFns } from "./PerfilPacienteNuevo.vue?vue&type=template&id=3ac17998&scoped=true"
import script from "./PerfilPacienteNuevo.vue?vue&type=script&lang=js"
export * from "./PerfilPacienteNuevo.vue?vue&type=script&lang=js"
import style0 from "./PerfilPacienteNuevo.vue?vue&type=style&index=0&id=3ac17998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac17998",
  null
  
)

export default component.exports